import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import AsyncAdsPanel from '../modals/AsyncAdsPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const PromoteAdCampaign = {
  id: CONTENT_ACTION_IDS.PROMOTE_AD_CAMPAIGN,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-details-ui.actions.names.promoteAdCampaign"
  }),
  ModalOrPanel: AsyncAdsPanel,
  tableRowActionGroup: 1,
  orderInTableRowActionGroup: 2,
  enablePermissions: {
    scopes: ['ads-write']
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-details-ui.actions.disabledTooltips.promoteAdCampaign"
  })
};